import { useEffect, useRef } from "react";
import gsap from "gsap";
import { PERSONAS } from "@/constants/data";
import { SelectionCard } from "@/components/SelectionCard";
import { StickyCTA } from "@/components/StickyCTA";

export const PersonaScreen = ({ selected, onSelect, onContinue, onBack }) => {
  const headerRef = useRef(null);
  const gridRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(headerRef.current?.children || [], {
        opacity: 0,
        y: 20,
        duration: 0.6,
        ease: "power3.out",
        stagger: 0.07,
      });
      gsap.from(gridRef.current?.children || [], {
        opacity: 0,
        y: 24,
        duration: 0.55,
        ease: "power3.out",
        stagger: 0.05,
        delay: 0.15,
      });
    });
    return () => ctx.revert();
  }, []);

  return (
    <section className="min-h-[calc(100vh-100px)] pt-4 md:pt-6 pb-8 md:pb-10 px-6 md:px-10 lg:px-16 2xl:px-24 max-w-7xl 3xl:max-w-[1600px] mx-auto flex flex-col">
      <div ref={headerRef} className="relative text-center mb-8 md:mb-10">
        <button
          type="button"
          onClick={onBack}
          data-testid="back-button"
          className="absolute left-0 top-0 z-10 text-xs tracking-[0.18em] uppercase text-zinc-500 dark:text-zinc-500 hover:text-zinc-900 dark:hover:text-zinc-300 transition-colors"
        >
          ← Back
        </button>
        <p className="text-xs tracking-[0.24em] uppercase text-zinc-500 dark:text-zinc-500 font-semibold mb-2">
          Step 03 — About You
        </p>
        <h1 className="text-3xl md:text-4xl lg:text-5xl 2xl:text-6xl font-medium tracking-tighter text-zinc-900 dark:text-zinc-50 leading-[1.05] font-display">
          Which best{" "}
          <span className="text-brand uppercase italic">describes you?</span>
        </h1>
        <p className="text-sm md:text-base text-zinc-600 dark:text-zinc-400 mt-2.5 max-w-2xl mx-auto">
          So we can speak to you, not at you.
        </p>
      </div>

      <div
        ref={gridRef}
        className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 flex-1 content-center auto-rows-fr"
      >
        {PERSONAS.map((p, i) => (
          <SelectionCard
            key={p.id}
            testId={`persona-card-${p.id}`}
            title={p.label}
            hint={p.hint}
            selected={selected?.id === p.id}
            onClick={() => onSelect(p)}
            index={i}
          />
        ))}
      </div>

      <StickyCTA
        label={selected ? "Reveal my numbers" : "Pick one"}
        disabled={!selected}
        onClick={onContinue}
      />
    </section>
  );
};
